import React, { Component } from "react";

import { Row, Col, Card } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import moment from "jalali-moment";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/InsuranceKnowledge/Books/Books.css";

const articleDetailsText = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".9em",
};
const articleDetailsTextTablet = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".8em",
};
const articleDetailsTextMobile = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#186491",
  fontSize: ".7em",
};

const articleDetailsTextRed = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".9em",
};
const articleDetailsTextRedTablet = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".8em",
};
const articleDetailsTextRedMobile = {
  fontFamily: "IranSans",
  direction: "rtl",
  textAlign: "right",
  paddingRight: "10px",
  color: "#ed1c24",
  fontSize: ".7em",
};

const articleDetailsTitle = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".9em",
};
const articleDetailsTitleTablet = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".85em",
};
const articleDetailsTitleMobile = {
  color: "#8d8d8d",
  direction: "rtl",
  textAlign: "right",
  fontFamily: "IranSans",
  fontSize: ".8em",
};

const ArticlesInsideCard = (props) => {
  console.log(props);
  return props.size === "laptopdesktop" ? (
    <div
      style={{
        borderRadius: "20px",
        backgroundColor: "#f6f6f6",
        padding: "25px",
        opacity: "90%",
      }}
    >
      <Row>
        <Col span={15}>
          <p
            className="articleBorder"
            style={{
              fontFamily: "IranSans",
              fontSize: "1.1em",
              color: "#174561",
              direction: "rtl",
              textAlign: "right",
              paddingRight: "10px",
              paddingTop: "5px",
            }}
          >
            <strong>{props.article.title}</strong>
          </p>
          <Margin top={4}></Margin>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsText}>{props.article.title}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>عنوان</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsText}>
                  {props.article.publish_location}
                </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>محل انتشار</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsText}>{props.article.writer} </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>نویسنده</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsTextRed}>
                  {props.article.language === 0 ? "فارسی" : "انگلیسی"}
                </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>زبان مقاله</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsTextRed}>
                  {" "}
                  {props.article.publish_date}
                </p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>سال انتشار</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Row>
            <Col span={18}>
              <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                <p style={articleDetailsTextRed}>{props.article.pages}</p>
              </div>
            </Col>
            <Col span={5}>
              <p style={articleDetailsTitle}>تعداد صفحات</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          <Margin top={4}></Margin>
          <Row>
            <Col span={12}>
              <a
                href={props.article.file}
                target="_blank"
                download
                class="introBtn introBtn-white introBtn-animated"
                style={{
                  fontSize: ".8em",
                  fontFamily: "IRANSans",
                  marginTop: "10px",
                  paddingRight: "30px",
                  paddingLeft: "30px",
                }}
              >
                دریافت مقاله
              </a>
            </Col>
            <Col span={12}></Col>
          </Row>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <Card
            style={{
              borderRadius: "10px",
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
            }}
          >
            <Center>
              <img style={{ width: "100%" }} src={props.article.image} />
            </Center>
          </Card>
        </Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
      <div
        style={{
          borderRadius: "20px",
          backgroundColor: "#f6f6f6",
          padding: "25px",
          opacity: "90%",
        }}
      >
        <Row>
          <Col span={15}>
            <p
              className="articleBorder"
              style={{
                fontFamily: "IranSans",
                fontSize: ".9em",
                color: "#174561",
                direction: "rtl",
                textAlign: "right",
                paddingRight: "10px",
                paddingTop: "5px",
              }}
            >
              <strong>{props.article.title}</strong>
            </p>
            <Margin top={4}></Margin>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextTablet}>{props.article.title}</p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>عنوان</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextTablet}>
                    {props.article.publish_location}
                  </p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>محل انتشار</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextTablet}>{props.article.writer} </p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>نویسنده</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextRedTablet}>
                    {props.article.language === 0 ? "فارسی" : "انگلیسی"}
                  </p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>زبان مقاله</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextRedTablet}>
                    {" "}
                    {props.article.publish_date}

                  </p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>سال انتشار</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Row>
              <Col span={18}>
                <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                  <p style={articleDetailsTextRedTablet}>{props.article.pages}</p>
                </div>
              </Col>
              <Col span={5}>
                <p style={articleDetailsTitleTablet}>تعداد صفحات</p>
              </Col>
              <Col span={1}></Col>
            </Row>
            <Margin top={2}></Margin>
            <Row>
              <Col span={12}>
                <a
                  href={props.article.file}
                  target="_blank"
                  download
                  class="introBtn introBtn-white introBtn-animated"
                  style={{
                    fontSize: ".75em",
                    fontFamily: "IRANSans",
                    marginTop: "10px",
                    paddingRight: "30px",
                    paddingLeft: "30px",
                  }}
                >
                  دریافت مقاله
              </a>
              </Col>
              <Col span={12}></Col>
            </Row>
          </Col>
          <Col span={1}></Col>
          <Col span={8}>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              }}
            >
              <Center>
                <img style={{ width: "100%" }} src={props.article.image} />
              </Center>
            </Card>
          </Col>
        </Row>
      </div>
  ) : (
        <div
          style={{
            borderRadius: "20px",
            backgroundColor: "#f6f6f6",
            padding: "25px",
            opacity: "90%",
          }}
        >
        <Row>
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              }}
            >
              <Center>
                <img style={{ width: "100%" }} src={props.article.image} />
              </Center>
            </Card>
        </Row>
          <Row>
            <Col span={24}>
              <p
                className="articleBorder"
                style={{
                  fontFamily: "IranSans",
                  fontSize: ".85em",
                  color: "#174561",
                  direction: "rtl",
                  textAlign: "right",
                  paddingRight: "10px",
                  paddingTop: "5px",
                }}
              >
                <strong>{props.article.title}</strong>
              </p>
              <Margin top={4}></Margin>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextMobile}>{props.article.title}</p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>عنوان</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextMobile}>
                      {props.article.publish_location}
                    </p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>محل انتشار</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextMobile}>{props.article.writer} </p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>نویسنده</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextRedMobile}>
                      {props.article.language === 0 ? "فارسی" : "انگلیسی"}
                    </p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>زبان مقاله</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextRedMobile}>
                      {" "}
                      {props.article.publish_date}

                    </p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>سال انتشار</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Row>
                <Col span={18}>
                  <div style={{ borderRadius: "10px", backgroundColor: "#fff" }}>
                    <p style={articleDetailsTextRedMobile}>{props.article.pages}</p>
                  </div>
                </Col>
                <Col span={5}>
                  <p style={articleDetailsTitleMobile}>تعداد صفحات</p>
                </Col>
                <Col span={1}></Col>
              </Row>
              <Margin top={2}></Margin>
              <Row>
                <Col span={12}>
                  <a
                    href={props.article.file}
                    target="_blank"
                    download
                    class="introBtn introBtn-white introBtn-animated"
                    style={{
                      fontSize: ".7em",
                      fontFamily: "IRANSans",
                      marginTop: "10px",
                      paddingRight: "30px",
                      paddingLeft: "30px",
                    }}
                  >
                    دریافت مقاله
              </a>
                </Col>
                <Col span={12}></Col>
              </Row>
            </Col>
           
          </Row>
        </div>
  );
};

export default ArticlesInsideCard;
